/** Comparing a period with the one before it (docs/07-Admin/Dashboard.md). */

/**
 * The change from the period before, as a card says it: a signed whole
 * percentage, or "new" when there was nothing before to compare with, or
 * nothing when both are nothing.
 */
export function changeFrom(current: number, previous: number): { percent: number | null; direction: 'up' | 'down' | 'flat' } {
  if (previous === 0) return current === 0 ? { percent: null, direction: 'flat' } : { percent: null, direction: 'up' };
  const percent = Math.round(((current - previous) / previous) * 100);
  return { percent, direction: percent > 0 ? 'up' : percent < 0 ? 'down' : 'flat' };
}
